import {FC} from 'react'

import {TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {CardContent} from '@/components/user-portal/card/CardContent'
import {useAuthContent} from '@/content/user/authentication'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

export const SignInBenefits: FC = () => {
  const {t} = useTranslation()
  const {benefits} = useAuthContent().signIn.mandatory

  return (
    <>
      <ul className="list">
        {benefits.map(({icon, title, description}) => (
          <li key={title} className="card">
            <CardContent
              icon={icon}
              title={t(title)}
              titleVariant={TextVariant.text16}
              titleElement="p"
              titleFontWeight={TextFontWeight.bold}
              description={t(description)}
            />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          margin-top: ${theme.spacing[8]};
          gap: ${theme.spacing[2]};
        }
        .card {
          flex: 1;
          padding: ${theme.spacing[4]} ${theme.spacing[5]} ${theme.spacing[6]};
          background-color: ${theme.palette.background.butter};
          border-radius: 8px;
        }
        @media ${MOBILE_SCREENSIZE} {
          .list {
            flex-direction: column;
            margin: ${theme.spacing[6]} 0 0;
          }
          .card {
            padding: ${theme.spacing[3.5]} ${theme.spacing[4]};
          }
        }
      `}</style>
    </>
  )
}
